import { render, staticRenderFns } from "./EvrakIndirIslemDetayView.vue?vue&type=template&id=849ea25e&scoped=true"
import script from "./EvrakIndirIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./EvrakIndirIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849ea25e",
  null
  
)

export default component.exports